import ReactOnRails from 'react-on-rails';

import setupMainNavigation from 'common/main_navigation';

// Core Components
import ToggleVAT from 'components/toggle_vat/toggle_vat';
import SiteSearch from 'components/site_search/site_search';
import TrustpilotStars from 'components/trustpilot/trustpilot_stars';
import HomepageCarousel from 'components/homepage_carousel/homepage_carousel';
import ProductCompareBar from 'components/product_compare_bar/product_compare';
import MFAOptInModal from 'components/mfa/opt_in/opt_in_modal/';
import ActivateAccountModal from 'components/AccountActivatedModal/';
import { Arrow } from 'assets/icons';

// TODO: Split out into seperate bundles for each of the following
import ApprovalCreditLimit from 'components/approval_credit_limit/approval_credit_limit';

import CareersCarousel from 'components/careers/careers_carousel';
import SelectStore from 'components/select_a_store/select_a_store';
import SimilarStockBrowserLocation from 'components/similar_stock/get_browser_location';
import SimilarStock from 'components/similar_stock/';

import RegisterForm from 'components/mycef/Register/';
import RegistrationModal from 'components/registration_modal/registration_modal';
import ActivateAccountForm from 'components/mycef/Register/RegisterForm/SubmissionViews/ActivateAccount/';

import TradeHubVideoList from 'components/trade_hub/video_list';
import VideoList from 'components/video/video_list';

import PocketGuides from 'components/niceic_pocket_guides/niceic_pocket_guides';
import Checkout from 'components/checkout';
import QuickOrder from 'components/quick_orders/quick_orders';

import TrustpilotCompanyReviews from 'components/trustpilot/trustpilot_company_reviews';
import TrustpilotCompanyInfo from 'components/trustpilot/trustpilot_company_info';
import MarketingBadgesSplide from 'components/marketing_badges/marketing_badges_splide';

import FeedbackForm from 'components/feedback_form/';

import NAArrow from 'components/national_accounts/na-arrow';
import NAChat from 'components/national_accounts/na-chat';
import NAChevron from 'components/national_accounts/na-chevron';
import NACheckIcon from 'components/national_accounts/na-check-icon';
import NASlider from 'components/national_accounts/na_slider';
import AboutUsSlider from 'components/about_us/about_us_slider';

import DisableUser from 'components/mycef/users/disable_user/';
import AccountChangeRequestForm from 'components/mycef/account_change_requests/account_change_request_form/';

import ApprovalsUnnasignedUsers from 'components/mycef/order_approvals/groups_users/approvals_unassigned_users';
import ApprovalsGroupForm from 'components/mycef/order_approvals/group_form/approvals_group_form';
import ApprovalsGroupListing from 'components/mycef/order_approvals/groups_listing/approvals_groups_listing';

import MFAChallengeForm from 'components/mfa/opt_in/challenge_form/';
import MFAVerifyMobileForm from 'components/mfa/opt_in/verify_mobile_form/';
import MFAToggle from 'components/mycef/mfa_toggle/';
import MFAOptOut from 'components/mfa/opt_out/';
import RequestPasswordResetForm from 'components/mycef/reset_password/passwordResetRequestForm';
import PasswordResetForm from 'components/mycef/reset_password';

import CMSBlog from 'components/blog/post/';
import CMSEventPage from 'components/event_page/';
import CMSEvergreen from 'components/evergreen/';
import CMSLibrary from 'components/contentful_library/';

ReactOnRails.register({
  // Core
  ToggleVAT,
  SiteSearch,
  TrustpilotStars,
  HomepageCarousel,
  ProductCompareBar,
  MFAOptInModal,
  ActivateAccountModal,
  RegistrationModal,
  Arrow,

  // TODO: Split into seperate bundles for each of the following
  ApprovalCreditLimit,

  CareersCarousel,
  SelectStore,
  SimilarStockBrowserLocation,
  SimilarStock,
  RegisterForm,
  ActivateAccountForm,
  TradeHubVideoList,
  PocketGuides,
  Checkout,
  QuickOrder,
  VideoList,
  TrustpilotCompanyReviews,
  TrustpilotCompanyInfo,
  MarketingBadgesSplide,
  FeedbackForm,
  NAArrow,
  NAChat,
  NACheckIcon,
  NAChevron,
  NASlider,
  AboutUsSlider,

  AccountChangeRequestForm,
  DisableUser,
  ApprovalsUnnasignedUsers,
  ApprovalsGroupForm,
  ApprovalsGroupListing,

  MFAChallengeForm,
  MFAVerifyMobileForm,
  MFAToggle,
  MFAOptOut,
  RequestPasswordResetForm,
  PasswordResetForm,

  // CMS
  CMSBlog,
  CMSEventPage,
  CMSLibrary,
  CMSEvergreen,
});

setupMainNavigation();
